import { GameMenuKey, IGameURLParams } from '../../../model';

export const isBuildRoute = () => {
  return location.pathname.startsWith('/console/build');
};

export const isConsoleRoute = () => {
  return location.pathname.startsWith('/console/');
};

export const isHomeRoute = () => {
  return location.pathname === '/';
};

export const isDocumentRoute = () => {
  return location.pathname.startsWith('/doc/detail');
};

export const formatGameParamsByLocationPathname = (
  pathname: string
): IGameURLParams => {
  const names = pathname.split('/').slice(3);
  return {
    gameId: names[0] || '',
    envId: names[1] || '',
    serviceId: names[2] || '',
  };
};

// url format collection

// in [overview、game-info、build] module, replace current env id or game id path
export const getPathnameBySwitchGameEnv = (envID: number, gameID?: string) => {
  const pathname = location.pathname.split('/');
  pathname.splice(4, 1, `${envID}`);
  if (gameID) {
    pathname.splice(3, 1, `${gameID}`);
  }
  return pathname.join('/');
};

// overview or game-info route
export const getPathnameByGameInfo = (key: GameMenuKey) => {
  const params = formatGameParamsByLocationPathname(location.pathname);
  return `/console/${key}/${params.gameId}/${params.envId}`;
};

// format to service url => /console/build/{gameID}/{envID}/{serviceID}
export const getPathnameByGameService = (serviceID: number) => {
  const params = formatGameParamsByLocationPathname(location.pathname);
  return `/console/build/${params.gameId}/${params.envId}/${serviceID}`;
};

// only two scenes
// enter to game for first time or switch games in the build route
export const getPathnameByGameChange = (envID: number) => {
  const prefix = location.pathname.split('/').slice(0, 4).join('/');
  return `${prefix}/${envID}`;
};
